class Controller {
  constructor($mdDialog, $injector, type) {
    "ngInject";

    this.type = type;
    this.$mdDialog = $mdDialog;
    this.$injector = $injector;
  }

  confirm() {
    const options = {
      captain: this.captain && this.captain._id,
      bus: this.bus && this.bus._id,
      bus_type: this.bustype && this.bustype._id,
    };

    this.$mdDialog.hide(options);
  }

  close() {
    this.$mdDialog.cancel();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/backup/changeDialog/changeDialog.controller.js